import { Route, Routes } from "react-router-dom";
import AlqemiArchiveDashboardProvider from "../context/AlqemiArchiveDashboardProvider";
import AlqemiArchiveDashboard from "./AlqemiArchiveDashboard";

export default function AlqemiArchiveRoutes() {
  const basePath = "/archive";

  return (
    <AlqemiArchiveDashboardProvider>
      <Routes>
        <Route index element={<AlqemiArchiveDashboard basePath={basePath} />} />
      </Routes>
    </AlqemiArchiveDashboardProvider>
  );
}